<template>
  <div class>
    <STable ref="tableref" :url="url" :columns="columns" :selection="false" :query="query" :handles="handles" :toolbar="toolbar" />
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  name: 'SubsidyManagement',
  data() {
    return {
      url: '/admin/subsidy/pageSubsidy',
      columns: [
        {
          label: '任务名称',
          prop: 'taskName'
        },
        {
          label: '任务模式',
          prop: 'taskType',
          template: function(index, record) {
            return record.taskType == '0' ? '补贴下发' : '补贴扣回'
          }
        },
        {
          label: '任务状态',
          prop: 'taskStatus',
          template: function(index, record) {
            return record.taskStatus == '0' ? '未开始' : record.taskStatus == '1' ? '进行中' : record.taskStatus == '2' ? '已终止' : '已结束'
          }
        },
        {
          label: '终止原因',
          prop: 'overReason',
          template: function(index, record) {
            return record.overReason == '0' ? '余额不足' : record.overReason == '1' ? '手动停止' : '--'
          }
        },
        {
          label: '修改人',
          prop: 'updateBy'
        },
        {
          label: '修改时间',
          prop: 'updateTime'
        }
      ],
      query: [
        {
          label: '任务名称',
          prop: 'taskName',
          placeholder: '请输入任务名称'
        },
        {
          label: '任务模式',
          prop: 'taskType',
          placeholder: '请选择任务模式',
          type: 'select',
          data: [
            {
              label: '补贴下发',
              value: '0'
            },
            {
              label: '补贴扣回',
              value: '1'
            }
          ]
        },
        {
          label: '任务状态',
          prop: 'taskStatus',
          placeholder: '请选择任务状态',
          type: 'select',
          data: [
            {
              label: '未开始',
              value: '0'
            },
            {
              label: '进行中',
              value: '1'
            },
            {
              label: '已终止',
              value: '2'
            },
            {
              label: '已结束',
              value: '3'
            }
          ]
        },
        {
          label: '终止原因',
          prop: 'overReason',
          placeholder: '请选择终止原因',
          type: 'select',
          data: [
            {
              label: '余额不足',
              value: '0'
            },
            {
              label: '手动停止',
              value: '1'
            }
          ]
        },
        {
          label: '修改时间',
          prop: 'updateTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'subsidy.add',
          type: 'primary',
          before: (index, record) => {
            this.$router.push({
              path: 'addSubsidy', query: { isclick: 1 }
            })
          }
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: '详情',
            permission: 'subsidy.detail',
            type: 'primary',
            handle: (resp) => {
              this.$router.push({
                path: './detailSubsidy', query: { id: resp.id, isclick: 0 }
              })
            }
          },
          {
            label: '修改',
            permission: 'subsidy.update',
            type: 'primary',
            getLabelDisabled: record => {
              return record.taskStatus != 0
            },
            handle: (resp) => {
              this.$router.push({
                path: './modifySubsidy', query: { id: resp.id, isclick: 1 }
              })
            }
          },
          {
            label: '停止',
            permission: 'subsidy.stop',
            type: 'primary',
            getLabelStyle: record => {
              return record.taskStatus > 1 ? 'color: #c0c4cc;cursor: not-allowed;' : 'color:red'
            },
            getLabelDisabled: record => {
              return record.taskStatus > 1
            },
            handle: (index, record) => {
              this.$confirm('此操作将停止当前任务，任务停止后不再下发/扣回补贴，是否继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$store.dispatch('form/handle', {
                  url: '/admin/subsidy/stopSubsidy',
                  data: {
                    id: index.id
                  },
                  method: 'post',
                  callback: resp => {
                    this.$refs.tableref.queryTable()
                  }
                })
              }).catch(() => {

              })
            }
          }
        ]
      }
    }
  },
  beforeMount() {},
  methods: {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/userManagement/subsidyManagement.vue